import axios from "axios";
import { opportunityUrl } from "./getOpportunity";
export default async function patchOpportunity(opportunityId, request, config) {
    await axios.patch(opportunityUrl(opportunityId), request, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
}
//# sourceMappingURL=patchOpportunity.js.map